<template>
  <div class="mall-order">
    <div class="page">
      <MallHeader @back-click="goBack">
        <MallIconButton slot="right" :icon="documentIcon" :alt="'이용내역'" @click="goHistory" />
      </MallHeader>

      <span class="mall-order__title">구매하기</span>

      <div v-if="isLoaded" class="mall-order__content">
        <MallOrderDelivery
          class="mall-order__section"
          :address="address"
          :recipientName="recipientName"
          :recipientPhone="recipientPhone"
          @recipient-name-input="recipientName = $event"
          @recipient-phone-input="recipientPhone = $event"
          @change-click="goAddressManage"
        />

        <div class="mall-order__thick-divider"></div>

        <MallOrderProducts class="mall-order__section" :items="items" :totalPrice="cost ? cost.total_cost : null" />

        <div class="mall-order__thick-divider"></div>

        <MallOrderPayment
          class="mall-order__section"
          :productAmount="productAmount"
          :discountAmount="discountAmount"
          :shippingFee="null"
          :totalAmount="totalAmount"
        />

        <div class="mall-order__thick-divider"></div>

        <MallOrderCard class="mall-order__section" :card="card" @change-click="goCardManage" />

        <div class="mall-order__section mall-order__divider"></div>

        <MallAgreeCheck
          class="mall-order__section"
          :checked="agreed"
          :label="'이용약관을 확인하였으며 결제에 동의합니다.'"
          @change="agreed = $event"
        />
      </div>

      <MallBottomBar :buttons="payButtons" @click="pay" />

      <MallToast
        v-if="toast"
        :key="toast.key"
        :title="toast.title"
        :message="toast.message"
        @close="toast = null"
      />
    </div>
  </div>
</template>

<script>
import Constant from '@/constant'
import mall from '@/utilities/mall.js'
import MallIconButton from '@/components/new/atoms/MallIconButton.vue'
import MallHeader from '@/components/new/molecules/MallHeader.vue'
import MallBottomBar from '@/components/new/molecules/MallBottomBar.vue'
import MallAgreeCheck from '@/components/new/molecules/MallAgreeCheck.vue'
import MallToast from '@/components/new/molecules/MallToast.vue'
import MallOrderDelivery from '@/components/new/organisms/MallOrderDelivery.vue'
import MallOrderProducts from '@/components/new/organisms/MallOrderProducts.vue'
import MallOrderPayment from '@/components/new/organisms/MallOrderPayment.vue'
import MallOrderCard from '@/components/new/organisms/MallOrderCard.vue'

export default {
  name: 'MallOrder',
  components: {
    MallIconButton,
    MallHeader,
    MallBottomBar,
    MallAgreeCheck,
    MallToast,
    MallOrderDelivery,
    MallOrderProducts,
    MallOrderPayment,
    MallOrderCard,
  },
  data() {
    return {
      profileId: Number(this.$route.query.profileId) || null,
      token: null,
      documentIcon: require('@/assets/mall/icn_document_line.svg'),

      // 프로필에 등록된 배송지 { isDefault, name, address, detailAddress, zipCode, description(배송 메모) }
      address: { isDefault: true, name: '', address: '', detailAddress: '', zipCode: '', description: '' },
      // TODO: 받는 분 / 연락처를 보내는 API 필드가 없어 화면에서만 입력
      recipientName: '',
      recipientPhone: '',

      // 장바구니 상품 [{ id, name, image, price(개당 원가), quantity }]
      items: [],
      // 결제 준비(checkout) 결과 금액 (서버 계산값)
      cost: null,
      recipientTypeCode: null,
      // 위임청구 적용 여부 (장바구니 해제 / 처방전 없이 바로 구매면 false → 전액 본인부담)
      delegationClaim: this.$route.query.delegationClaim !== 'false',

      // 프로필에 등록된 간편결제 카드 (API 원본, 없으면 null)
      cardInfo: null,
      // 결제 준비 응답(payment_info.card_info)의 카드사 로고 / 빌링키
      cardLogoUrl: '',
      billingKeyId: '',

      agreed: false,
      isLoaded: false,
      // 결제 준비가 끝나야 결제 가능
      isCheckedOut: false,
      isRequesting: false,
      toast: null,
    }
  },
  computed: {
    productAmount() {
      return this.cost ? this.cost.total_cost : 0
    },
    // 공단 부담 등 본인부담금을 뺀 금액
    discountAmount() {
      return this.cost ? this.cost.total_cost - this.cost.patient_cost : 0
    },
    totalAmount() {
      return this.cost ? this.cost.patient_cost : 0
    },
    card() {
      if (!this.cardInfo) return null
      var name = this.cardInfo.card_name || ''
      return {
        companyName: name,
        number: this.cardInfo.card_number,
        // 서버 카드사 로고(60px 원형 배지)가 없으면 국민카드만 앱 이미지
        logo: this.cardLogoUrl || (/국민|KB/i.test(name) ? require('@/assets/mall/img_card_kb.png') : ''),
        isBadgeLogo: !!this.cardLogoUrl,
      }
    },
    canPay() {
      return this.agreed && this.isCheckedOut && !!this.cardInfo && !!this.address.address && !this.isRequesting
    },
    payButtons() {
      return [
        { key: 'pay', label: '결제하기', type: 'primary', disabled: !this.canPay },
      ]
    },
  },
  watch: {
    recipientPhone(value) {
      var digits = String(value).replace(/[^0-9]/g, '')
      if (digits !== value) {
        this.recipientPhone = digits
      }
    },
  },
  mounted() {
    ChannelIO('shutdown')
    this.token = mall.getAccessToken()
    if (!this.token) {
      mall.goLogin(this.$router)
      return
    }
    var catalog = null
    // 프로필 목록 조회 실패는 오류 내용 없이 reject돼 상품 조회 오류(인증 등)로 처리
    Promise.all([
      mall.fetchProfile(this.$store, this.profileId, this.token).catch(() => null),
      mall.fetchCatalog(this.$store, this.profileId, this.token),
    ])
      .then((results) => {
        this.setProfile(results[0])
        catalog = results[1]
        return this.$store.dispatch(Constant.FETCH_CART, { profile_id: this.profileId, token: this.token })
      })
      .then((cart) => {
        this.items = ((cart && cart.items) || []).map((item) => {
          var product = catalog.productMap[item.product_id]
          return {
            id: item.product_id,
            name: product ? product.name : '판매가 종료된 상품',
            image: mall.productImage(product ? product.image_url : null),
            price: product ? product.price : 0,
            quantity: item.quantity,
          }
        })
        this.isLoaded = true
        if (this.items.length === 0) {
          this.toast = { key: Date.now(), title: '주문할 상품이 없어요.', message: '장바구니에 상품을 담아 주세요.' }
          return null
        }
        return this.checkout()
      })
      .catch((err) => this.handleError(err))
  },
  methods: {
    setProfile(data) {
      if (!data) return
      var profile = data.profile
      this.address = {
        isDefault: true,
        name: profile.address_nickname || '배송지',
        address: profile.address || '',
        detailAddress: profile.detail_address || '',
        zipCode: profile.zip_code || '',
        description: profile.address_description || '',
      }
      this.cardInfo = data.card_info || null
    },
    // 결제 준비 - 서버가 금액을 다시 계산하고 진료를 만듦 (다시 불러도 진료는 중복 생성되지 않음)
    checkout() {
      var info = mall.getPurchaseInfo(this.profileId)
      this.recipientTypeCode = mall.getRecipientTypeCode(info)
      return this.$store.dispatch(Constant.CHECKOUT_CART, {
        profile_id: this.profileId,
        date_count: mall.getDateCount(info) || 0,
        recipient_type_code: this.recipientTypeCode,
        is_delegation_claim: this.delegationClaim,
        token: this.token,
      })
        .then((data) => {
          var cardInfo = (data.payment_info && data.payment_info.card_info) || {}
          this.cardLogoUrl = cardInfo.logo_url || ''
          this.billingKeyId = cardInfo.billing_key || ''
          this.cost = data.cost
          this.isCheckedOut = true
        })
    },
    handleError(err) {
      this.isLoaded = true
      if (mall.isAuthError(err)) {
        mall.goLogin(this.$router)
        return
      }
      this.toast = { key: Date.now(), title: '주문 정보를 불러오지 못했어요.', message: mall.errorMessage(err) }
    },
    goBack() {
      mall.goBack(this.$router, this.$route, { path: '/mall/prescription', query: { profileId: this.profileId } })
    },
    goHistory() {
      this.$router.push({ path: '/mall/history', query: { profileId: this.profileId } })
    },
    // 카드 / 배송지 관리에서 뒤로가면 이 화면으로 돌아오도록 returnTo 전달
    // 돌아오면 화면이 다시 만들어져 프로필(카드, 배송지)을 새로 불러옴
    goCardManage() {
      this.$router.push({ path: '/mall/card', query: { profileId: this.profileId, returnTo: this.$route.fullPath } })
    },
    goAddressManage() {
      this.$router.push({ path: '/mall/address', query: { profileId: this.profileId, returnTo: this.$route.fullPath } })
    },
    pay() {
      if (!this.canPay) return
      this.isRequesting = true
      this.$store.dispatch(Constant.PAY_CART, {
        payment: {
          profile_id: this.profileId,
          // BillingKey 스키마 - 결제서버가 읽는 키는 id(결제 준비 응답의 빌링키) / payment_method 둘뿐
          // TODO: 할부 선택 화면이 없어 일시불로 결제 (결제 준비 응답 payment_info.interest에 할부 개월 목록이 옴)
          billing_key: {
            id: this.billingKeyId || this.cardInfo.billing_key || null,
            payment_method: { type: 'payInFull', month: 0 },
          },
          // AddressInfo 스키마 - address / zipcode 필수 (비어 있으면 400)
          address_info: {
            address: this.address.address,
            zipcode: this.address.zipCode,
            detail_address: this.address.detailAddress || null,
            address_description: this.address.description || null,
          },
          // checkout에 보낸 값과 같아야 함
          recipient_type_code: this.recipientTypeCode,
        },
        token: this.token,
      })
        .then(() => {
          // TODO: 결제 응답의 guide_banner(교차 안내 배너)를 완료 화면에 노출
          // 뒤로가기로 구매하기 화면에 다시 오지 않도록 replace
          this.$router.replace({ path: '/mall/order/complete', query: { profileId: this.profileId } })
        })
        .catch((err) => {
          this.isRequesting = false
          if (mall.isAuthError(err)) {
            mall.goLogin(this.$router)
            return
          }
          this.$router.replace({ path: '/mall/order/fail', query: { profileId: this.profileId, message: err.message } })
        })
    },
  },
}
</script>

<style scoped>
  .mall-order {
    display: flex;
    width: 100%;
    min-height: 100vh;
    justify-content: center;
    align-items: flex-start;
  }
  /* 하단 고정 버튼 영역(90px)에 마지막 항목이 가려지지 않도록 */
  .page {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 90px;
    background: #FFF;
    box-sizing: border-box;
  }
  .mall-order__title {
    display: block;
    padding: 0 20px;
    color: var(--color-text-main);
    font-family: Pretendard;
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-semibold);
    line-height: var(--line-height-normal);
  }
  .mall-order__content {
    display: flex;
    margin-top: 32px;
    padding-bottom: 32px;
    flex-direction: column;
    gap: 24px;
  }
  .mall-order__section {
    margin: 0 16px;
  }
  .mall-order__thick-divider {
    height: 12px;
    background: #F2F4F6;
  }
  .mall-order__divider {
    height: 1px;
    background: #F2F4F6;
  }
  @media (min-width: 600px) {
    .page {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/new/MallOrder.vue